import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import CustomizedBreadcrumbs from "../../components/Custom/CustomizedBreadcrumbs";
import CustomizedMenuList from "../../components/Custom/CustomizedMenuList";
import { IBreadcrumbsAndMenu } from "../../types/global";
import { hasPermission } from "../../utils/Global";
import { useStateContext } from "../../contexts/auth-context";

const Inventory = () => {
  const { t } = useTranslation();
  const {
    state: { permissions },
  } = useStateContext();

  const breadcrumbs: IBreadcrumbsAndMenu[] = [
    {
      name: t("inventory.index"),
    },
  ];

  const menuList: IBreadcrumbsAndMenu[] = [
    {
      name: t("inventory.items.index"),
      to: "/inventory/items",
      permissionKey: "item",
    },
    {
      name: t("inventory.goods_receive.index"),
      to: "/inventory/goods-receive",
      permissionKey: "goods_receive",
    },
    {
      name: t("inventory.goods_return.index"),
      to: "/inventory/goods-return",
      permissionKey: "goods_return",
    },
    {
      name: t("inventory.goods_issue.index"),
      to: "/inventory/goods-issue",
      permissionKey: "goods_issue",
    },
    {
      name: t("inventory.goods_transfer.index"),
      to: "/inventory/goods-transfer",
      permissionKey: "goods_transfer",
    },
    {
      name: t("inventory.goods_adjustment.index"),
      to: "/inventory/goods-adjustment",
      permissionKey: "goods_adjust",
    },
    {
      name: t("inventory.price_list.index"),
      to: "/inventory/price-list",
      permissionKey: "price_list",
    },
    {
      name: t("inventory.preorder_quota.index"),
      to: "/inventory/preorder-quota",
    },
    {
      name: t("report"),
      to: "/inventory/report",
      permissionKey: "inventory_report",
    },
  ].filter((item) => hasPermission(item.permissionKey, permissions));

  return (
    <Fragment>
      <CustomizedBreadcrumbs breadcrumbs={breadcrumbs} />
      <CustomizedMenuList menuList={menuList} />
    </Fragment>
  );
};

export default Inventory;
